import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { preview } from "../../../helpers/preview";
import * as commondata from "../../../Common";

const MainCellRenderer = (data) => {
  try {
    const params = useParams();

    if (data.colDef?.attribute_type === "url" && data?.value) {
      return (
        <a href={data.value} target="_blank">
          Link
        </a>
      );
    }
    if (data.colDef.field === "sequence") {
      const {
        columnApi: {
          columnModel: { columnDefs },
        },
      } = data.column;
      const status = columnDefs.filter((item) => item.field === "status");
      let statusget = data.data?.status;
      const getcolor = status?.[0]?.options.find(
        (item) => item._id === statusget
      );
      const colorretrive = commondata.hexToRgba(getcolor?.color, 1);
      return (
        <div className="tattle-id-check">
          {/* <label className="prime" style={colorretrive}></label> */}
          <span
            to="/"
            onClick={(et) => {
              data.colDef.cellRendererParams.childFunc(
                data,
                data.data.customer_tattle_uuid
              );
              et.preventDefault();
            }}
            className="child_board_sereal"
          >
            {data.data.sequence}
          </span>
        </div>
      );
    }
    if (
      data.data &&
      data.data[data?.colDef?.field] !== undefined &&
      data.colDef.field === "customer_tattle_uuid"
    ) {
      if (data.colDef.cellRendererParams?.child) {
        return (
          <Link
            to="/"
            onClick={(et) => {
              data.colDef.cellRendererParams.childFunc(data);
              et.preventDefault();
            }}
          >
            {data.value}
          </Link>
        );
      } else {
        if (data.data.completed == "true" || data.data.completed == true) {
          return (
            <div className="tattle-id-check strike-out">
              <Link
                to={{
                  pathname: `/tattle/${data.data.attribute_set_key}/${data.value}`,
                }}
              >
                {data.value}
              </Link>
            </div>
          );
        }
        return (
          <div className="tattle-id-check">
            <Link
              to={{
                pathname: `/tattle/${data.data.attribute_set_key}/${data.value}`,
              }}
            >
              {data.value}
            </Link>
          </div>
        );
      }
    }
    if (
      data.data &&
      data.data[data?.colDef?.field] !== undefined &&
      data.colDef.attribute_type === "text"
    ) {
      if (data.data.completed == "true" || data.data.completed == true) {
        return <span className="strike-out">{data.value}</span>;
      }
      return <span>{data.value}</span>;
    }
    if (
      data.data &&
      data.data[data?.colDef?.field] !== undefined &&
      data.colDef.attribute_type === "textarea"
    ) {
      return (
        <>
          <span
            dangerouslySetInnerHTML={{
              __html:
                data.value.length > 150
                  ? data.value.slice(0, 150) + "..."
                  : data.value,
            }}
          ></span>
        </>
      );
    }

    if (
      data.data &&
      data.data[data?.colDef?.field] !== undefined &&
      data.colDef.field === "actions"
    ) {
      return (
        <>
          {" "}
          <Link
            to={`/board/edit/${data.data.customer_tattle_uuid}`}
            className="edit-form"
          >
            <i className="fa fa-edit"></i>
          </Link>
        </>
      );
    }

    if (
      data.data &&
      data.data[data?.colDef?.field] !== undefined &&
      data.colDef.attribute_type === "age"
    ) {
      return data.value === 0 ? 0 : data.value;
    }

    if (
      data.data &&
      data.data[data?.colDef?.field] !== undefined &&
      data.colDef.attribute_type === "last_update_since"
    ) {
      return data.value === 0 ? data.value : data.value ? data.value : "";
    }

    if (data.colDef.is_system_variable === true) {
      if (
        data.data &&
        data.data[data?.colDef?.field] !== undefined &&
        data.colDef.attribute_type === "status"
      ) {
        const celldata = data.colDef?.options;
        const stat = celldata?.find((item) => {
          return item?._id === data?.data[data?.colDef?.field];
        });
        if (stat) {
          return (
            <span class={`badge bg-${stat?.color} status_label_details`}>
              {stat?.name}
            </span>
          );
        } else if (
          data.colDef?.options?.find((item) => item.is_default === true)
        ) {
          const statm = data.colDef?.options?.find(
            (item) => item.is_default === true
          );
          return (
            <span className={`badge bg-${statm?.color} status_label_details`}>
              {statm?.name}
            </span>
          );
        } else {
          return data?.value?.name;
        }
      }

      if (
        data.data &&
        data.data[data?.colDef?.field] !== undefined &&
        data.colDef.attribute_type === "er"
      ) {
        const options = { ...data.colDef.options };
        const values =
          data.value &&
          data.value.map((mki, index, data) => {
            if (index + 1 === data.length) {
              return [
                <span
                  onClick={() =>
                    window.open(
                      options[mki]?.url ||
                        `${process.env.REACT_APP_VIEW_ER_LINK}${mki}`,
                      "_blank",
                      "noopener"
                    )
                  }
                  className="link-er"
                  key={index}
                >
                  {mki}
                </span>,
              ];
            } else {
              return [
                <span
                  onClick={() =>
                    window.open(
                      options[mki]?.url ||
                        `${process.env.REACT_APP_VIEW_ER_LINK}${mki}`,
                      "_blank",
                      "noopener"
                    )
                  }
                  className="link-er"
                  key={index}
                >
                  {mki}
                </span>,
                ",",
              ];
            }
          });

        return values;
      }
      if (
        data.data &&
        data.data[data?.colDef?.field] !== undefined &&
        data.colDef.attribute_type === "category"
      ) {
        const celldata = data.colDef?.options;
        const stat = celldata?.find((item) => {
          return item._id === data.data[data.colDef.field];
        });
        return <span>{stat?.name}</span>;
      } else {
        if (data.colDef?.options?.length > 0) {
          const elestatus = data.colDef?.options?.find(
            (item) => item.is_default === true
          );
          return (
            <span
              className={`badge bg-${elestatus?.color} status_label_details`}
            >
              {elestatus?.name}
            </span>
          );
        }
      }
    }

    if (data.colDef.attribute_type === "attachment") {
      return (
        data.value &&
        Object.keys(data.value).map((item) => {
          return (
            <img
              src={data.value[item].file_url}
              width={50}
              height={40}
              onClick={() => preview.previewImage(data.value[item].file_url)}
              style={{ cursor: "pointer", marginRight: "5px" }}
            />
          );
        })
      );
    }
    if (data.colDef.attribute_type === "account_manager") {
      const { data: rowData } = data;
      const { account_manager: accountManager } = rowData?.customers;
      const { options } = data?.colDef;

      const managervalue = options?.data;

      if (accountManager) {
        const findmanager = managervalue.find(
          (it) => it.user_uuid === accountManager
        );

        return (
          findmanager?.name && (
            <>
              <img
                src={findmanager?.attachment}
                className="rounded-circle rci"
              />{" "}
              <span>{findmanager?.name}</span>
            </>
          )
        );
      }
    }
    if (data.colDef.attribute_type === "sales_manager") {
      const { data: rowData } = data;
      const { sales_manager: accountManager } = rowData?.customers || {}; // Ensure rowData.customers exists
      const { options } = data?.colDef;
      const managervalue = options?.data || []; // Ensure options.data exists

      if (accountManager) {
        const findmanager = managervalue.find(
          (it) => it.user_uuid === accountManager
        );

        return (
          findmanager?.name && (
            <>
              <img
                src={findmanager?.attachment}
                className="rounded-circle rci"
              />{" "}
              <span>{findmanager?.name}</span>
            </>
          )
        );
      }
    }
    if (data.colDef.attribute_type === "tse_owner") {
      const { data: rowData } = data;
      const { tse_owner: accountManager } = rowData?.customers;
      const { options } = data?.colDef;
      const managervalue = options?.data;

      if (accountManager) {
        const findmanager = managervalue.find(
          (it) => it.user_uuid === accountManager
        );
        return (
          findmanager?.name && (
            <>
              <img
                src={findmanager?.attachment}
                className="rounded-circle rci"
              />{" "}
              <span>{findmanager?.name}</span>
            </>
          )
        );
      }
    }
    if (data.colDef.attribute_type === "company_name") {
      const {
        customers: { company_name },
      } = data.data;
      return commondata.firstUpper(company_name || "");
    }
    if (data.colDef.attribute_type === "name") {
      const {
        customers: { name },
      } = data.data;
      return commondata.firstUpper(name || "");
    }
    if (data.colDef.attribute_type === "customer_type") {
      const { data: rowData } = data;
      const {
        customers: { customer_type, key_account },
      } = rowData;
      return key_account == 1 ? (
        <>
          {commondata.firstUpper(customer_type)} (
          <a className="key_account">Key Account</a>)
        </>
      ) : (
        commondata.firstUpper(customer_type)
      );
    } else {
      if (typeof data.value === "string") {
        return data.value;
      } else {
        if (typeof data.value === "array") {
          return "ok";
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export default MainCellRenderer;
